import { render, staticRenderFns } from "./DonationAgencyCard.vue?vue&type=template&id=f21bcbc8&scoped=true"
import script from "./DonationAgencyCard.vue?vue&type=script&lang=js"
export * from "./DonationAgencyCard.vue?vue&type=script&lang=js"
import style0 from "./DonationAgencyCard.vue?vue&type=style&index=0&id=f21bcbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21bcbc8",
  null
  
)

export default component.exports